export enum GeoAppEvents {
    toggleLayerSelector = 'toggleLayerSelector',
    featureClicked = 'geoApp:featureClicked',
    displayShare = 'displayShare',
    queryPoint = 'geoApp:queryPoint',
    removeUnsavedPins = 'geoApp:removeUnsavedPins',
    resetMapAndLayers = 'geoApp:resetMapAndLayers',
    closePrint = 'closePrint',
    treeChange = 'onTreeChange',
    layerToggled = 'layerToggled',
    showSelectedLayer = 'showSelectedLayer',
    showToolbar = 'show-toolbar',
    hideToolbar = 'hide-toolbar',
    showLegendAndMetadata = 'geoApp:showLegendAndMetaData',
    eagerForLayers = 'geoApp:eagerForLayers',
}